var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
import { REQUEST_TIMEOUT } from '../constants/general';
import { generateXB3TraceID, getChannelID, getHost, getTmxId, isSsr, } from '../utils/general';
import { getAuthorizationToken } from '../utils/user';
var baseurl = getHost();
var channelId = getChannelID();
var TMXProfileID = isSsr ? '' : getTmxId();
var Client = 'ocm_pd_experience_customer-account-orders-purchases';
var baseConfig = {
    baseURL: baseurl,
    headers: {
        channelId: channelId,
        TMXProfileID: TMXProfileID,
        Authorization: getAuthorizationToken(),
        'X-B3-TraceId': generateXB3TraceID(),
        Client: Client,
    },
    timeout: REQUEST_TIMEOUT,
};
export var b2cConfig = {
    baseURL: baseurl,
    headers: {
        channelId: channelId,
        TMXProfileID: TMXProfileID,
        Authorization: getAuthorizationToken(),
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Client: Client,
    },
    timeout: REQUEST_TIMEOUT,
};
export var b2bConfig = {
    baseURL: baseurl,
    headers: {
        channelId: channelId,
        TMXProfileID: TMXProfileID,
        'X-B3-TraceId': generateXB3TraceID(),
        Client: Client,
    },
    timeout: REQUEST_TIMEOUT,
};
export var rmsConfig = {
    baseUrl: baseurl,
    headers: {
        channelId: channelId,
        Client: Client,
        Cookie: '', // THD_CUSTOMER cookie for b2b, THD_USER_SESSION for b2c. Only one should be present
        // TraceId: generateXB3TraceID(),
    },
    timeout: REQUEST_TIMEOUT,
};
export var cmsConfig = {
    baseUrl: baseurl,
    headers: {
        channelId: channelId,
        Client: Client,
        Cookie: '', // THD_CUSTOMER cookie for b2b, THD_USER_SESSION for b2c. Only one should be present
        // TraceId: generateXB3TraceID(),
    },
    timeout: REQUEST_TIMEOUT,
};
export var ommConfig = {
    baseUrl: baseurl,
    headers: {
        channelId: channelId,
        Client: Client,
        Cookie: '', // THD_CUSTOMER cookie for b2b, THD_USER_SESSION for b2c. Only one should be present
        // TraceId: generateXB3TraceID(),
    },
    timeout: REQUEST_TIMEOUT,
};
/**
 * Speical Client Function for buildertrend link and unlink
 * @param code - buildertrend code from given from buildertrend when hitting
 * our page. Must be passed in header under 'BT-Code'
 */
var getBuildertrendAxiosClient = function (code) {
    var integrationClientBase = {
        baseURL: baseurl,
        headers: {
            channelId: channelId,
            TMXProfileID: TMXProfileID,
            'X-B3-TraceId': (Math.random().toString(16).substring(2) +
                new Date().getTime().toString(16)).substring(0, 15),
            'BT-Code': code,
        },
    };
    return integrationClientBase;
};
var apiBase = axios.create(baseConfig);
var apiB2C = axios.create(b2cConfig);
var apiB2B = axios.create(b2bConfig);
var apiRMS = axios.create(rmsConfig);
var apiCMS = axios.create(cmsConfig);
var apiOMM = axios.create(ommConfig);
var apiBaseWithBlob = axios.create(__assign(__assign({}, baseConfig), { responseType: 'blob' }));
var apiB2BWithBlob = axios.create(__assign(__assign({}, b2bConfig), { responseType: 'blob' }));
/* export const integrationClientChannelId = {
  client: axios.create({ ...integrationClientBase, responseType: 'json' }),
}; */
export { apiBase, apiB2C, apiB2B, apiRMS, apiCMS, apiOMM, apiBaseWithBlob, apiB2BWithBlob, getBuildertrendAxiosClient, };
